import Vue from '@triotech/vue-core/src/vendor/vue';
import AjaxMixin from '@triotech/vue-core/src/mixins/plugins/ajax';

const Ajax = new Vue({
  mixins: [
    AjaxMixin,
  ],
  methods: {
    addVersionInConfig(config = {}) {
      if (!config.headers) {
        config.headers = [];
      }

      config.headers = this._.extend({
        Version: this.$config.get('api.version'),
      }, config.headers);

      return config;
    },
    addSubEndPointToUrl(url = '') {
      return this.$config.get('subendpoint') + url;
    },
    getUploadsUri(location) {
      return this.url(this.build(`uploads${location}`), true);
    },
    build(url, method, data = {}, config = {}) {
      return this._.extend(url === this.oauthTokenEndpoint ? config : this.addVersionInConfig(config), { url, method, data });
    },
    loggingByToken(data, persistSession = true) {
      return this.oauth(this._.extend({
        grant_type: 'urn:switch_token',
      }, data), persistSession);
    },
    get(url, data, config) {
      return this.request(this.build(this.addSubEndPointToUrl(url), this.http.get, data, config));
    },
    patch(url, data, config) {
      return this.request(this.build(this.addSubEndPointToUrl(url), this.http.patch, data, config));
    },
    smartLogin(token){
      return this.publicRequest('public/smartlogin/'+token).then((response) => {
        response.expires_at = this.expires(response.expires_in);
        response.refresh_token_expires_at = this.expires(response.refresh_token_lifetime);
        this.set({ oauth: this._.extend(this.oauthStore, response) });

        return response;
      });
    }
  },
});

Vue.set(Vue.prototype, '$ajax', Ajax);

export default Ajax;
